import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
export function useCountdown(): {
  hours: string;
  minutes: string;
  seconds: string;
} {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor(remaining % 3600 / 60)),
    seconds: pad(remaining % 60)
  };
}
interface CountdownProps {
  className?: string;
}
export function Countdown({
  className = ''
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const blocks: {
    value: string;
    label: string;
  }[] = [{
    value: hours,
    label: 'HOURS'
  }, {
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEC'
  }];
  return <div className={`flex items-stretch justify-center gap-2 ${className}`} role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-20" data-mp="159263vrlfgvz">
      {blocks.map((block, i) => <React.Fragment key={block.label} data-id="element-21" data-mp="17poilif1xwq4" data-mpi={i}>
          <div className="flex min-w-[74px] flex-col items-center rounded-xl border border-white/15 bg-navy-950/70 px-3 py-2.5 sm:min-w-[88px]" data-id="element-22" data-mp="17sswj7ibk6tz">
            <span className="font-display text-3xl font-bold tabular-nums text-gold-400 sm:text-4xl" data-id="element-23" data-mp="f3dh85jmfrs9">
              {block.value}
            </span>
            <span className="mt-0.5 text-[10px] font-bold tracking-[0.18em] text-white/55" data-id="element-24" data-mp="a5ke5ldm7dw7">
              {block.label}
            </span>
          </div>
          {i < blocks.length - 1 && <span className="self-center font-display text-2xl font-bold text-gold-500/60" data-id="element-25" data-mp="k3rrlu8p3dtg">:</span>}
        </React.Fragment>)}
    </div>;
}